import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import "./Contact2.css"
function ContactForm() {
    const [state, handleSubmit] = useForm("mdobrkyg");
    if (state.succeeded) {
        return <p></p>;
    }
    return (
        <div className='right2'>
            <form onSubmit={handleSubmit}>
                <div className='f_flex'>
                    <div className='input1 row'>
                        <span>YOUR NAME</span>
                        <textarea
                            id="message"
                            name="message"
                        />
                        <ValidationError
                            prefix="Message"
                            field="message"
                            errors={state.errors}
                        />
                    </div>

                    <div className='input1 row'>
                        <span>PHONE NUMBER</span>
                        <textarea
                            id="message"
                            name="message"
                        />
                        <ValidationError
                            prefix="Message"
                            field="message"
                            errors={state.errors}
                        />
                    </div>
                </div>

                <div className='input1'>
                    <label htmlFor="email">
                        <span> Email Address </span> 
                    </label>
                    <input
                        id="email"
                        type="email"
                        name="email"
                    />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                    />
                </div>

                <div className='input1'>
                    <span>SUBJECT </span>
                    <textarea
                        id="message"
                        name="message"
                    />
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                </div>

                <div className='input1'>
                    <span>Your Message</span>
                    <textarea
                        id="message"
                        name="message"
                    />
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                </div>


                <button className='btn_shadow' type="submit" disabled={state.submitting}>
                    Submit <i className='fa fa-long-arrow-right'></i>
                </button>
            </form>
        </div>

    );
}
function App() {
    return (
        <ContactForm />
    );
}
export default App;
